import { computed } from 'vue';
import useAcvStore from '@/composables/useAcvStore';
import useAcvAnalytics from '@/composables/useAcvAnalytics';
import useAcvAuth from '@/composables/useAcvAuth';

/**
 * Toggles the panda MFE VDP version preference and tracks the change
*/
const usePandaVdpVersionToggle = () => {
  const store = useAcvStore();
  const analytics = useAcvAnalytics();
  const { currentUser } = useAcvAuth();

  const vdpVersionPreference = computed(() => store.state.pandaMfe.vdpVersionPreference);

  const toggleVdpVersionPreference = async ({ forceTrue = false } = {}) => {
    const oldValue = forceTrue ? false : vdpVersionPreference.value;
    const newValue = forceTrue ? true : !vdpVersionPreference.value;

    await store.dispatch('pandaMfe/toggleVdpVersionPreference', { forceTrue });

    analytics.track(
      analytics.eventNames.marketplaceV2.vdp3ToggleChanged,
      {
        user_id: currentUser.value?.id,
        dealer_id: currentUser.value?.defaultDealerId,
        old_value: oldValue,
        new_value: newValue,
      },
      { withPendo: true },
    );
  };

  return {
    vdpVersionPreference,
    toggleVdpVersionPreference,
  };
};

export default usePandaVdpVersionToggle;
